import LoginComponent from '../../components/Login/Login'
import React from 'react'
import LoginModule from './login.module.scss'
import UserNotificationModule from '../../components/Common/UserNotification.module.scss'

function Login() {
  return (
    <div className={LoginModule['main']}>
      <div className={`${UserNotificationModule['notification-container']}`}>
        <div className={`${UserNotificationModule['notification-inner-container']}`}>
          こちらは2024年度スクールAIです。
          <br />
          7月末に閉鎖されますので、それまでに
          <a href="https://school-ai-app.mingaku.net" target="_blank" rel="noopener noreferrer">
            2025年度スクールAI
          </a>
          に移動をお願いいたします。
          <br />
          <span className={`${UserNotificationModule['notification-small-text']}`}>
            ※2025年度スクールAIには、チャットログと提出ボックスの内容が引き継がれません。
            <a
              href="https://plaid-scallop-d50.notion.site/2025-1d1f1977e4b780d4a340ed1f4f937a1c"
              target="_blank"
              rel="noopener noreferrer"
            >
              マニュアル
            </a>
            を見て保存をお願いいたします。
          </span>
        </div>
      </div>
      <div className={LoginModule['title-container']}>
        <div>
          <div className={LoginModule['service-title']}>スクールAI</div>
          <div className={LoginModule['term']}>
            ログインを以て{' '}
            <a
              href="https://drive.google.com/file/d/1HfNFqVDUF-ntYGa-SIVHRHg8VD-wx9Vg/view"
              target="_blank"
              rel="noreferrer"
              className={LoginModule['term-link']}
            >
              利用規約
            </a>
            に同意します
          </div>
          <br />
        </div>
      </div>
      <LoginComponent type={'student'} path={'/'} signup={'/signup'} />
    </div>
  )
}
export default Login
